<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import { numeric, required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import { pagingModel } from "@/models/core/pagingModel";
import DatePicker from "vue2-datepicker";
import Treeselect from "@riophae/vue-treeselect";
import { commonModel } from "@/models/common/commonModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { commonValidator } from "@/models/common/commonValidator";
import VueMultiselect from "vue-multiselect";
import { handleApiResponse } from "@/utils/api/apiResponseHandler";
import { STATUS_CODES } from "@/utils/api/apiConstants";
import SearchCard from "@/components/search-card.vue";
import {
  ButtonCore,
  SearchResetButtons,
  // ActionButtons,
} from "@/components/widgets";

import CustomTable from "@/components/custom-table.vue";


export default {
  page: {
    title: "Danh sách danh mục",
    meta: [{ name: "common", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ValidationObserver,
    ValidationProvider,
    VueMultiselect,
    ButtonCore,
    SearchCard, CustomTable
  },
  data() {
    return {
      title: "Danh sách danh mục",
      items: [
        {
          text: "Danh sách danh mục",
          href: "/danh-sach",
        },
        {
          text: "Danh sách",
          active: true,
        },
      ],

      listCollection: [],
      data: [],
      fields: [
        {
          key: "STT",
          label: "STT",
          class: "td-stt",
          sortable: false,
          thClass: "hidden-sortable",
        },
        {
          key: "name",
          label: "Tên danh mục",
          class: "td-username",
          sortable: false,
          thStyle: "text-align:center",
          thClass: "hidden-sortable  text-uppercase",
        },
        {
          key: "process",
          label: "Xử lý",
          class: "td-XuLy text-center ",
          sortable: false,
          thClass: "hidden-sortable text-uppercase",
          thStyle: { width: "90px", minWidth: "60px" },
        },
      ],

      actionDefinitions: [
        {
          type: "edit",
          text: "Sửa",
          // iconClass: "fas fa-pencil-alt",
          variantClass: "btn-edit-core",
          needsId: true,
          customStyle: {
            height: "30px",
          },
        },
        {
          type: "delete",
          text: "Xóa",
          // iconClass: "fas fa-trash-alt",
          variantClass: "btn-delete-core",
          needsId: true, // Chỉ truyền item._id
          customStyle: {
            height: "30px",
          },
        },
      ],

      // Table data
      errors: {}, // Object to hold validation errors
      commonValidator,

      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 25, 50, 100],
      showModal: false,
      showDeleteModal: false,
      submitted: false,
      sortBy: "age",
      filter: null,
      sortDesc: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      model: commonModel.baseJson(),

      isSubmitting: false,

      commonShort: null,
      pagination: pagingModel.baseJson(),
      itemFilter: {
        content: null,
        commonShort: {
          name: null,
          code: null,
        },
      },
      searchFields: [
        {
          key: "content",
          type: "text",
          label: "Nội dung",
          placeholder: "Tìm kiếm theo tên danh mục",
          col: 6,
        },
      ],
      list: [],
    };
  },

  created() {
    //   this.GetPagingParam();

    this.fnGetListCommonDM().then(() => {
      this.getData();
    });
    //    this.GetListParent();
  },
  computed: {
    parentCategoryName() {
      if (this.model && this.model.id && this.model.collectionName) {
        // console.log(
        //   "LOG parentCategoryName by model : ",
        //   this.model.collectionName
        // );
        return this.model.collectionName;
      }
      if (this.itemFilter.commonShort && this.itemFilter.commonShort.name) {
        // console.log(
        //   "LOG parentCategoryName by commonShort : ",
        //   this.itemFilter.commonShort.name
        // );
        return this.itemFilter.commonShort.name;
      }
      return "N/A";
    },
    parentCategoryCode() {
      if (this.model && this.model.id && this.model.collectionName) {
        // console.log(
        //   "LOG parentCategoryName by model : ",
        //   this.model.collectionName
        // );
        return this.model.collectionName;
      }
      if (this.itemFilter.commonShort && this.itemFilter.commonShort.name) {
        // console.log(
        //   "LOG parentCategoryName by commonShort : ",
        //   this.itemFilter.commonShort.code
        // );
        return this.itemFilter.commonShort.code;
      }
      return "N/A";
    },
  },
  methods: {
    handleShowModalCreate() {
      this.showModal = true;
    },

    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },

    async getData() {
      let params = {
        start: this.currentPage,
        limit: this.perPage,
        content: this.itemFilter.content,
        collectionName: this.itemFilter.commonShort.code
          ? this.itemFilter.commonShort.code
          : null,
      };
      await this.$store
        .dispatch("common/commonStore/getPagingParams", params)
        .then((res) => {
          if (
            res &&
            res.data &&
            STATUS_CODES.SUCCESS_VALUES.includes(res.code)
          ) {
            this.list = res.data.data;
            this.totalRows = res.data.totalRows;
          } else {
            this.list = [];
            this.totalRows = 0;
            // this.$store.dispatch("snackBarStore/addNotify", res);
            this.$store.dispatch("snackBarStore/addNotify", {
              code: res.code,
              message: res.message,
            });
          }
        })
        .catch((error) => {
          console.error("Lỗi khi tải dữ liệu danh mục:", error);
          this.list = [];
          this.totalRows = 0;
          // this.$store.dispatch("snackBarStore/addNotify", {
          //   code: "ERROR",
          //   message: "Không thể tải dữ liệu danh mục.",
          // });
          this.$store.dispatch("snackBarStore/addNotify", {
            code: -1,
            message: "Không thể tải dữ liệu danh mục.",
          });
        });
    },
    // async fnGetList() {
    //   this.$refs.tblList?.refresh();
    // },
    async handleDelete() {
      if (this.model._id) {
        const payload = commonModel.toDeleteJson(
          this.model,
          this.parentCategoryCode
        );

        // console.log("LOG PAYLOAD DELETE NE :", payload);

        const res = await this.$store.dispatch(
          "common/commonStore/delete",
          payload
        );

        if (res.code === 0) {
          this.getData();
          this.showDeleteModal = false;
        }

        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: res.code,
            message: res.message,
          },
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model._id = id;
      this.showDeleteModal = true;
    },

    async fnGetListCommonDM() {
      await this.$store
        .dispatch("common/commonStore/getAllCollection")
        .then((res) => {
          if (handleApiResponse(res)) {
            this.listCollection = res.data || [];
            this.itemFilter.commonShort = this.listCollection[0];
            this.commonShort = this.listCollection[0];
          } else {
            this.listCollection = [];
            this.itemFilter.commonShort = null;
            this.commonShort = null;
            this.$store.dispatch("snackBarStore/addNotify", {
              code: res.code,
              message: res.message,
            });
          }
        })
        .catch((error) => {
          console.error("Lỗi khi tải danh sách danh mục:", error);
          this.listCollection = [];

          this.$store.dispatch("snackBarStore/addNotify", {
            code: -1,
            message: "Không thể tải danh sách danh mục.",
          });
        });
    },

    async onSubmit(e) {
      // console.log("LOG HANDLE SUBMIT NE : ");
      try {
        this.submitted = true;
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        // Tạo một bản sao của model để tránh thay đổi dữ liệu gốc

        const payload = commonModel.convertJson(
          this.model,
          this.model.collectionName
        );
        payload.collectionName = this.parentCategoryCode;
        let actionPromise;
        if (payload._id) {
          // Update
          actionPromise = this.$store.dispatch(
            "common/commonStore/update",
            payload
          );
        } else {
          // Create
          actionPromise = this.$store.dispatch(
            "common/commonStore/create",
            payload
          );
        }
        // console.log(`handleSubmit() with model: `, payload);
        await actionPromise
          .then((res) => {
            if (handleApiResponse(res)) {
              this.getData();
              this.model = commonModel.baseJson();
              this.showModal = false;
              this.$store.dispatch("snackBarStore/addNotify", {
                message: res.message,
                code: res.code,
              });
            } else {
              this.$store.dispatch("snackBarStore/addNotify", {
                message: res.message,
                code: res.code,
              });
            }
            // this.$store.dispatch("snackBarStore/addNotify", res);
          })
          .catch((error) => {
            console.error("Lỗi khi gửi form:", error);
            this.$store.dispatch("snackBarStore/addNotify", {
              code: -1,
              message: error,
            });
          });

        loader.hide();
        this.submitted = false;
      } catch (err) {
        console.error("Error during form submission validation:", err);
      }
    },

    async handleUpdate(id) {
      // console.info("LOG ID NE : ", id);
      let params = {
        _id: id,
        collectionName: this.itemFilter.commonShort.code
          ? this.itemFilter.commonShort.code
          : null,
      };

      await this.$store
        .dispatch("common/commonStore/getById", params)
        .then((res) => {
          if (res.code === 0) {
            // console.log(res);

            this.model = commonModel.toJson(res.data);

            // console.log("LOG handleUpdate NE 2: ", this.model);

            this.showModal = true;
          } else {
            this.$store.dispatch("snackBarStore/addNotify", {
              message: res.message,
              code: res.code,
            });
          }
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    handleClear() {
      this.itemFilter = {
        content: null,
        collectionName: null,
      };
      this.commonShort = this.listCollection[0];
      this.currentPage = 1;
    },
  },
  mounted() { },
  watch: {
    currentPage(newVal, oldVal) {
      this.getData();
    },
    perPage(newVal, oldVal) {
      this.currentPage = 1;
      this.getData();
    },
    commonShort(newVal, oldVal) {
      this.itemFilter.commonShort = newVal;
    },
    model: {
      deep: true,
      handler(val) {
        // addCoQuanToModel()
        // this.saveValueToLocalStorage()
      },
    },
    showModal(status) {
      if (status == false) this.model = commonModel.baseJson();
    },

    showDeleteModal(val) {
      if (val == false) {
        this.model._id = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="category-list-container">

      <!-- Header của trang danh sách -->
      <header class="header-wrapper">
        <div>
          <PageHeader :title="title" :items="items" class="p-0 m-0 border-0" />
        </div>
        <!-- Nút thêm mới danh mục -->
        <button @click="handleShowModalCreate" class="add-btn-style">
          <span class="isax isax-add-circle icon-btn-add"></span>
          Thêm danh mục mới
        </button>
      </header>

      <div class="row">
        <div class="col-12">
          <div class="card-premium">

            <!-- Bộ lọc tìm kiếm tái sử dụng chuẩn Bento -->
            <SearchCard :value="itemFilter" :fields="searchFields" @search="handleSearch" @clear="handleClear">
              <div class="mb-3 col-lg-6">
                <label class="filter-label">Tên Collection</label>
                <VueMultiselect v-model="itemFilter.commonShort" :options="listCollection" label="name" track-by="code"
                  placeholder="Chọn tên Collection" />
              </div>
            </SearchCard>

            <!-- Điều khiển hiển thị số dòng của Bảng -->
            <div class="table-controls-bar">
              <div class="pagination-control-row">
                <span>Hiển thị</span>
                <select v-model="perPage" class="per-page-select">
                  <option v-for="opt in pageOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <span>dòng trên mỗi trang</span>
              </div>
            </div>

            <!-- Bảng quản trị (Sử dụng component CustomTable tái sử dụng) -->
            <CustomTable :items="list" :fields="fields" striped bordered responsive="sm" :per-page="perPage"
              v-model="currentPage" :number-of-element="numberOfElement" :total-rows="totalRows" ref="tblList"
              primary-key="_id">
              <template v-slot:cell(STT)="data">
                {{ data.index + (currentPage - 1) * perPage + 1 }}
              </template>

              <template v-slot:cell(name)="data">
                <div v-if="data.item.name" class="d-flex justify-content-left font-semibold">
                  {{ data.item.name }}
                </div>
              </template>

              <template v-slot:cell(process)="data">
                <div class="action-buttons-flex">
                  <!-- Nút Sửa -->
                  <button type="button" class="action-btn btn-success-custom" @click="handleUpdate(data.item._id)"
                    title="Chỉnh sửa thông tin">
                    <span class="isax isax-edit-2 text-base"></span>
                  </button>

                  <!-- Nút Xoá -->
                  <button type="button" class="action-btn btn-danger-custom"
                    @click="handleShowDeleteModal(data.item._id)" title="Xóa danh mục">
                    <span class="isax isax-trash text-base"></span>
                  </button>
                </div>
              </template>
            </CustomTable>

          </div>
        </div>
      </div>

      <!-- MODAL THÊM/SỬA DANH MỤC BENTO GRID -->
      <b-modal v-model="showModal" title="Thông tin danh mục" title-class="modal-delete-title text-success-custom"
        body-class="p-4" centered hide-footer no-close-on-backdrop size="lg">
        <ValidationObserver v-slot="{ invalid, handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)" ref="formContainer">
            <div class="row">
              <div class="col-md-6 form-group-custom">
                <ValidationProvider :rules="commonValidator.rules.name" name="Tên danh mục" v-slot="{ errors }">
                  <label class="form-label-custom">Tên danh mục <span class="text-danger">*</span></label>
                  <input v-model="model.name" class="form-control-custom" placeholder="Nhập tên danh mục"
                    :class="{ 'is-invalid': errors[0] }" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>

              <div class="col-md-6 form-group-custom">
                <ValidationProvider :rules="commonValidator.rules.code" name="Code" v-slot="{ errors }">
                  <label class="form-label-custom">Code danh mục <span class="text-danger">*</span></label>
                  <input v-model="model.code" class="form-control-custom" placeholder="Nhập code danh mục"
                    :class="{ 'is-invalid': errors[0] }" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>

              <div class="col-12 form-group-custom">
                <label class="form-label-custom">Thuộc danh mục</label>
                <input :value="parentCategoryName" type="text" class="form-control-custom" disabled />
              </div>
            </div>
          </form>
          <div class="d-flex justify-content-end pt-3 mt-4 flower-footer-actions" style="gap: 8px;">
            <ButtonCore text="Đóng" variantClass="btn-close-core" :handleClick="() => (showModal = false)"
              :customStyle="{ margin: '0' }" />

            <!-- Nút Lưu -->
            <ButtonCore :text="isSubmitting ? 'Đang lưu...' : 'Lưu danh mục'" variantClass="btn-accept-core"
              iconClass="fas fa-save" :handleClick="onSubmit" :isDisable="invalid || isSubmitting" />
          </div>
        </ValidationObserver>
      </b-modal>

      <!-- MODAL XÓA DANH MỤC -->
      <b-modal v-model="showDeleteModal" centered title="Xóa dữ liệu"
        title-class="modal-delete-title text-danger-custom" no-close-on-backdrop>
        <p class="text-left font-body">Dữ liệu xóa sẽ không được phục hồi!</p>
        <template #modal-footer>
          <ButtonCore text="Đóng" variantClass="btn-close-core" :handleClick="() => (showDeleteModal = false)"
            modalTarget="modal-close_visit" :customStyle="{ width: '90px', margin: '0' }" />

          <ButtonCore text="Xóa" variantClass="btn-danger-core" iconClass="fas fa-trash" :handleClick="handleDelete"
            modalTarget="modal-close_visit" :customStyle="{ width: '100px', margin: '0' }" />
        </template>
      </b-modal>
    </div>
  </Layout>
</template>

<style scoped>
/* ======================== CHỦ ĐỀ CHUNG & KHUNG BÊN NGOÀI ======================== */
.category-list-container {
  padding: 0 12px;
}

.header-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  gap: 16px;
}

@media (min-width: 768px) {
  .header-wrapper {
    flex-direction: row;
    align-items: flex-end;
  }
}

/* Nút thêm mới */
.add-btn-style {
  padding: 12px 24px;
  border-radius: 8px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
  transition: all 0.2s ease-in-out;
}

.add-btn-style:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.25);
  transform: translateY(-1px);
}

.icon-btn-add {
  font-size: 18px;
}

/* ======================== THẺ CARD CAO CẤP ======================== */
.card-premium {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid rgba(187, 202, 186, 0.3);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 24px;
}

.filter-label {
  display: block;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 8px;
}

/* Điều khiển dòng hiển thị */
.table-controls-bar {
  padding: 16px 24px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.1);
  background-color: rgba(241, 245, 235, 0.3);
}

.pagination-control-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  color: var(--color-public-text-body, #374151);
}

.per-page-select {
  border: 1px solid rgba(187, 202, 186, 0.5);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  outline: none;
  background-color: #ffffff;
  font-weight: 600;
  color: var(--color-public-text-body, #374151);
}

/* Hộp nút thao tác xử lý trong dòng bảng */
.action-buttons-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(187, 202, 186, 0.3);
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-success-custom {
  color: var(--color-status-success, #4caf50);
}

.btn-success-custom:hover {
  background-color: rgba(76, 175, 80, 0.08);
  border-color: var(--color-status-success, #4caf50);
}

.btn-danger-custom {
  color: var(--color-status-error, #d32f2f);
}

.btn-danger-custom:hover {
  background-color: rgba(211, 47, 47, 0.08);
  border-color: var(--color-status-error, #d32f2f);
}

/* Form Styles */
.form-group-custom {
  margin-bottom: 20px;
  text-align: left;
}

.form-label-custom {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 6px;
  display: block;
}

.form-control-custom {
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 8px;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  color: var(--color-public-text-body, #374151);
  background-color: #ffffff;
  outline: none;
  transition: all 0.15s ease-in-out;
}

.form-control-custom:focus {
  border-color: var(--color-public-primary, #2e7d32);
  box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.1);
}

/* Modal Title */
::v-deep .modal-delete-title {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.text-success-custom {
  color: var(--color-public-primary, #2e7d32) !important;
}

.text-danger-custom {
  color: var(--color-status-error, #d32f2f) !important;
}
</style>
